import { PageErrorProps } from "./types";

export const PageError = ({ message, messageDetail }: PageErrorProps) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center text-red-600">
        <p className="font-semibold">{message}</p>
        <p className="text-sm mt-1">{messageDetail}</p>
      </div>
    </div>
  );
};
